import React from "react";
import { Modal, Form, Col, Container } from "react-bootstrap";
import InputComponent from "../../components/UI/InputComponent/InputComponent";
import Dropdown from "../../components/UI/Dropdown/Dropdown";
import "./StrucnaUsavrsavanja.css";
import Upload from "../UI/Upload/Upload";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import DatepickerComponent from "../../components/UI/DatePicker/DatepickerComponent";
import { useSelector } from "react-redux";
import moment from "moment";
const DodajStrucnoUsavrsavanje = (props) => {
  let ulogeSudionika = props.dropdownUlSudionika.map((element) => (
    <option key={element.id} value={element.id}>
      {element.naziv}
    </option>
  ));

  const visionImpaired = useSelector((state) => state.layout.visionImpaired);
  const fontSize = useSelector((state) => state.layout.fontSize);

  const isRevSatiEmpty = !props.formData.revSati ? (props.formData.revSati === 0 ? false : true) : false;
  const isRevBodoviEmpty = !props.formData.revBodovi ? (props.formData.revBodovi === 0 ? false : true) : false;

  const isRacSatiEmpty = !props.formData.racSati ? (props.formData.racSati === 0 ? false : true) : false;
  const isRacBodoviEmpty = !props.formData.racBodovi ? (props.formData.racBodovi === 0 ? false : true) : false;

  const isOstSatiEmpty = !props.formData.ostSati ? (props.formData.ostSati === 0 ? false : true) : false;
  const isOstBodoviEmpty = !props.formData.ostBodovi ? (props.formData.ostBodovi === 0 ? false : true) : false;

  return (
    <>
      <Modal
        show={props.dodavanjeModal}
        onHide={props.hideModalDodavanje}
        size="xl"
        centered
        style={{ zIndex: "999999" }}
        className={`${
          visionImpaired ? " visionImpaired" : ""
        }  font${fontSize}`}
      >
        <Modal.Header closeButton>
          {props.isEdit ? (
            <Modal.Title>Ažuriraj stručno usavršavanje</Modal.Title>
          ) : (
            <Modal.Title>Dodaj novo stručno usavršavanje</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={props.submitHandler}>
            <Container>
              <Form.Row style={{ paddingBottom: "12px" }}>
                <Col md={3}>
                  <DatepickerComponent
                    required
                    id="datPoc"
                    value={props.formData.datPoc}
                    handleDayClick={props.datePickerHandler}
                    index={{ id: "datPoc" }}
                    controlLabel="Datum od"
                    errorBorderColor={
                      props.error && !props.formData.datPoc && "red"
                    }
                    width={"100%"}
                  />
                </Col>
                <Col md={3}>
                  <DatepickerComponent
                    required
                    id="datZav"
                    value={props.formData.datZav}
                    handleDayClick={props.datePickerHandler}
                    index={{ id: "datZav" }}
                    controlLabel="Datum do"
                    errorBorderColor={
                      props.error && !props.formData.datZav && "red"
                    }
                    width={"100%"}
                  />
                </Col>
                <Col md={6}>
                  <label>Dokument</label>
                  <Upload
                    id="obrazac"
                    onChange={props.uploadObrazacHandler}
                    selectedFiles={props.obrazacData.selectedFile}
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col>
                  <InputComponent
                    id="organizator"
                    value={props.formData.organizator}
                    onChange={props.userInputHandler}
                    type="text"
                    controlLabel="Organizator*"
                    style={props.error && (!props.formData.organizator || props.formData.organizator.length > 200) && "red"}
                  />
                </Col>
                <Col>
                  <Dropdown
                    value={props.formData.oznPolEdu}
                    onChange={props.dropdownUlSudHandler}
                    hidden
                    asProperty="select"
                    map={ulogeSudionika}
                    text="Uloga sudionika"
                    label="Uloga sudionika*"
                    id="ulogaSudionika"
                    style={props.error && !props.formData.oznPolEdu && "red"}
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col>
                  <InputComponent
                    id="podrucje"
                    value={props.formData.podrucje}
                    onChange={props.userInputHandler}
                    type="text"
                    controlLabel="Područje aktivnosti*"
                    style={props.error && (!props.formData.podrucje || props.formData.podrucje.length > 200) && "red"}
                  />
                </Col>
                <Col>
                  <InputComponent
                    id="nazAktivnosti"
                    value={props.formData.nazAktivnosti}
                    onChange={props.userInputHandler}
                    type="text"
                    controlLabel="Naziv aktivnosti*"
                    name="nazAktivnosti"
                    style={
                      props.error && (!props.formData.nazAktivnosti || props.formData.nazAktivnosti.length > 200) && "red"
                    }
                  />
                </Col>
              </Form.Row>

              <hr></hr>
              <Form.Row>
                <Col md={{ span: 3, offset: 1 }} className="inputsLabel">
                  <label>Revizijska područja:</label>
                </Col>
                <Col>
                  <InputComponent
                    id="revSati"
                    value={props.formData.revSati}
                    onChange={props.userInputHandlerNum}
                    controlLabel={"Sati"}
                    style={props.error && isRevSatiEmpty == true && "red"}
                  />
                </Col>
                <Col>
                  <InputComponent
                    id="revBodovi"
                    value={props.formData.revBodovi}
                    onChange={props.userInputHandlerNum}
                    controlLabel={"Bodovi"}
                    style={props.error && isRevBodoviEmpty == true && "red"}
                  />
                </Col>
                <Col>
                  <InputComponent
                    disabled
                    id="revGodina"
                    controlLabel={"Godina"}
                    value={
                      moment(props.formData.datPoc, "DD.MM.YYYY").year() || ""
                    }
                    onChange={props.userInputHandler}
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col md={{ span: 3, offset: 1 }} className="inputsLabel">
                  <label>Računovodstvena područja:</label>
                </Col>
                <Col>
                  <InputComponent
                    id="racSati"
                    value={props.formData.racSati}
                    onChange={props.userInputHandlerNum}
                    style={props.error && isRacSatiEmpty == true && "red"}
                  />
                </Col>
                <Col>
                  <InputComponent
                    id="racBodovi"
                    value={props.formData.racBodovi}
                    onChange={props.userInputHandlerNum}
                    style={props.error && isRacBodoviEmpty == true && "red"}
                  />
                </Col>
                <Col>
                  <InputComponent
                    disabled
                    id="racGodina"
                    value={
                      moment(props.formData.datPoc, "DD.MM.YYYY").year() || ""
                    }
                    onChange={props.userInputHandler}
                  />
                </Col>
              </Form.Row>
              <Form.Row>
                <Col md={{ span: 3, offset: 1 }} className="inputsLabel">
                  <label>Ostala područja:</label>
                </Col>
                <Col>
                  <InputComponent
                    id="ostSati"
                    value={props.formData.ostSati}
                    onChange={props.userInputHandlerNum}
                    style={props.error && isOstSatiEmpty == true && "red"}
                  />
                </Col>
                <Col>
                  <InputComponent
                    id="ostBodovi"
                    value={props.formData.ostBodovi}
                    onChange={props.userInputHandlerNum}
                    style={props.error && isOstBodoviEmpty == true && "red"}
                  />
                </Col>

                <Col>
                  <InputComponent
                    disabled
                    id="ostGodina"
                    value={
                      moment(props.formData.datPoc, "DD.MM.YYYY").year() || ""
                    }
                  />
                </Col>
              </Form.Row>

              <Form.Row>
                <Col md={{ span: 3, offset: 1 }} className="inputsLabel">
                  <label>Ukupno aktivnosti:</label>
                </Col>
                <Col>
                  <InputComponent
                    id="brSati"
                    disabled
                    value={
                      +props.formData.revSati +
                      +props.formData.racSati +
                      +props.formData.ostSati
                    }
                    onChange={props.userInputHandlerNum}
                    style={props.error && "red"}
                  />
                </Col>
                <Col>
                  <InputComponent
                    id="brBodova"
                    disabled
                    value={
                      +props.formData.revBodovi +
                      +props.formData.racBodovi +
                      +props.formData.ostBodovi
                    }
                    onChange={props.userInputHandlerNum}
                    style={props.error && "red"}
                    type="text"
                  />
                </Col>

                <Col>
                  <InputComponent
                    id="godina"
                    value={
                      moment(props.formData.datPoc, "DD.MM.YYYY").year() || ""
                    }
                    disabled
                    max="9999"
                    min="0"
                  />
                </Col>
              </Form.Row>
              {
                //novi fieldovi
              }

              <Form.Row>
                <Col md={{ span: 3, offset: 1 }} className="inputsLabel">
                  <label>U tome područja s oznakom A:</label>
                </Col>
                <Col>
                  <InputComponent
                    id="satiPodrucjeA"
                    value={props.formData.satiPodrucjeA}
                    onChange={(e) => {
                      //ako je value inputa veci od zbroja sati => nope

                      if (
                        +e.target.value >
                        +props.formData.revSati +
                          +props.formData.racSati +
                          +props.formData.ostSati
                      ) {
                        return;
                      }

                      props.userInputHandlerNum(e);
                    }}
                    min="0"
                    max={9999}
                  />
                </Col>
                <Col>
                  <InputComponent
                    id="bodoviPodrucjeA"
                    value={props.formData.bodoviPodrucjeA}
                    onChange={(e) => {
                      //ako je value inputa veci od zbroja svih ostalih bodova => nope
                      if (
                        +e.target.value >
                        +props.formData.revBodovi +
                          +props.formData.racBodovi +
                          +props.formData.ostBodovi
                      ) {
                        return;
                      }

                      props.userInputHandlerNum(e);
                    }}
                  />
                </Col>

                <Col>
                  <InputComponent
                    id="godina"
                    value={
                      moment(props.formData.datPoc, "DD.MM.YYYY").year() || ""
                    }
                    disabled
                  />
                </Col>
              </Form.Row>
            </Container>
            <ButtonComponent
              loading={props.isLoading}
              style={{ float: "right" }}
              type="submit"
            >
              Potvrdi
            </ButtonComponent>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <ButtonComponent onClick={props.hideModalDodavanje} variant="danger">
            Odustani
          </ButtonComponent>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DodajStrucnoUsavrsavanje;
